import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { MapPage } from '../map/map'

import { GlobalsProvider } from '../../providers/globals/globals';

import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';
import { LoadingController } from 'ionic-angular';

@Component({
  selector: 'page-maplist',
  templateUrl: 'maplist.html',
})
export class MaplistPage {

  gorod: string = 'Казань';
  items: Array<{ id: number, code: string, name: string }>;
  item: any;
  goroda = ['Абакан', 'Анадырь', 'Архангельск', 'Астрахань', 'Барнаул', 'Белгород', 'Биробиджан', 'Благовещенск', 'Брянск', 'Великий Новгород', 'Владивосток', 'Владикавказ', 'Владимир', 'Волгоград', 'Вологда', 'Воронеж', 'Горно-Алтайск', 'Грозный', 'Екатеринбург', 'Иваново', 'Ижевск', 'Йошкар-Ола', 'Иркутск', 'Казань', 'Калининград', 'Калуга', 'Кемерово', 'Киров', 'Котельники', 'Краснодар', 'Красноярск', 'Курган', 'Курск', 'Кызыл', 'Липецк', 'Магадан', 'Магас', 'Майкоп', 'Махачкала', 'Москва', 'Мурманск', 'Набережные Челны', 'Назрань', 'Нальчик', 'Нарьян-мар', 'Нижний Новгород', 'Новосибирск', 'Омск', 'Орел', 'Оренбург', 'Пенза', 'Пермь', 'Петрозаводск', 'Петропавловск-Камчатский', 'Псков', 'Республика Карелия', 'Ростов-на-Дону', 'Рязань', 'Салехард', 'Самара', 'Санкт-Петербург', 'Саранск', 'Саратов', 'Севастополь', 'Симферополь', 'Смоленск', 'Ставрополь', 'Сыктывкар', 'Тамбов', 'Тверь', 'Томск', 'Тула', 'Тюмень', 'Улан-Удэ', 'Ульяновск', 'Уфа', 'Хабаровск', 'Ханты-Мансийск', 'Чебоксары', 'Челябинск', 'Черкесск', 'Чита', 'Элиста', 'Южно-Сахалинск', 'Якутск', 'Ярославль'];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public params: GlobalsProvider,
    public loadingCtrl: LoadingController,
    public http: Http
  ) {

    if (navParams.get('gorod')) this.gorod = navParams.get('gorod');

    let loadingPopup = this.loadingCtrl.create({
      content: ''
    });

    loadingPopup.present();
    console.log(this.params.apiURL + '?act=map-types&gorod='+this.gorod+'&id_lang='+this.params.id_lang);
    this.http.get(this.params.apiURL + '?act=map-types&gorod='+this.gorod+'&id_lang='+this.params.id_lang)
      .timeout(20000)
      .map(res => res.json())
      .subscribe(
        data => {
          setTimeout(() => {
            console.log('Категории карты подгружены.');
            this.items = data;

            loadingPopup.dismiss();

          }, 1000);

        },

        err => {
          loadingPopup.dismiss();
          alert('Ошибка загрузки');
          //this.error = "1";
        }

      );

    /*this.items = [
      { id: 'police', name: 'Отделы полиции' },
      { id: 'doctor', name: 'Медицинские учреждения' },
      { id: 'courthouse', name: 'Суды' },
      { id: 'church', name: 'Религиозные учреждения' },
      { id: 'bank', name: 'Денежные переводы' },
      { id: 'lawyer', name: 'Юридические услуги' },
      { id: 'embassy', name: 'Посольства' },
      { id: 'post_office', name: 'Почтовые отделения' },
      { id: 'shopping_mall', name: 'Торговые центры' },
      { id: 'hospital', name: 'Больницы' }
    ];*/

    

  }

  changeGorod() {
    this.navCtrl.push(MaplistPage, {
      gorod: this.gorod
    });    
  }


  openMap(item) {
    // That's right, we're pushing to ourselves!
      this.navCtrl.setRoot(MapPage, {
        id: item.id,
        code: item.code,
        gorod: this.gorod
      });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MaplistPage');
  }

  ionViewWillEnter() {
    this.params.stat('map');    
  }   

}



// WEBPACK FOOTER //
// ./src/pages/maplist/maplist.ts